import {UnItem} from "../../shared/models/un-item";

export class FiltersUnList implements UnItem {
    constructor(
        id: number,
        selected: boolean,
        public columnId: string,
        public name: string
    ){
        this.id = id;
        this.selected = selected;
        this.position = 0;
        this.disabled = false;
    }

    public id: number;
    public selected: boolean;
    public position: number;
    public disabled: boolean;
}



// WEBPACK FOOTER //
// ./src/app/stocks/models/filters-un-list.ts